var map = {
	"./Blog Post.svg": "8660",
	"./Collection Page.svg": "9136",
	"./Complete Store.svg": "fbd4",
	"./Home Page.svg": "a260",
	"./Landing Page.svg": "548e",
	"./Product Page.svg": "1f8c",
	"./starter.svg": "d24e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eed0";